/**
 * @todo: TECH DEBT
 * Step type is also used by entity onboarding.
 * Step type can be moved to a shared location at a later time when both features are deployed.
 */

export type Step = {
  key: string;
  title: string;
};

export const TierStep: Step = {
  key: "tier",
  title: "Options Trading Tier",
};

export const FinancialProfileStep: Step = {
  key: "financial-profile",
  title: "Financial Profile",
};

export const InvestmentExperienceStep: Step = {
  key: "investment-experience",
  title: "Investment Experience",
};

export const AgreementStep: Step = {
  key: "agreement",
  title: "Agreement",
};

export const STEPS: Step[] = [
  // TierStep,
  FinancialProfileStep,
  InvestmentExperienceStep,
  AgreementStep,
];

export default STEPS;
